export const indexIn = (values: number[]) => (value: any, index: number) => values.includes(index);

export const indexNotIn = (values: number[]) => (value: any, index: number) =>
  !values.includes(index);

export function getLastElement<T>(values: T[]): T | null {
  return values.length > 0 ? values[values.length - 1] : null;
}

export function getAddedValuesBy<T>(before: T[], after: T[], selector: (value: T) => any) {
  return getAddedValues<T>(
    before,
    after,
    (beforeElement, afterElement) => selector(beforeElement) === selector(afterElement),
  );
}

export function getAddedValues<T>(
  before: T[],
  after: T[],
  compare: (beforeElement: T, afterElement: T) => boolean = (beforeElement, afterElement) =>
    beforeElement === afterElement,
) {
  const addedValues = [...after];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < before.length; i++) {
    const element = before[i];
    const index = addedValues.findIndex((v) => compare(element, v));
    if (index !== -1) {
      addedValues.splice(index, 1);
    }
  }
  return addedValues;
}

export function getRemovedValuesBy<T>(before: T[], after: T[], selector: (value: T) => any) {
  return getRemovedValues(
    before,
    after,
    (beforeElement, afterElement) => selector(beforeElement) === selector(afterElement),
  );
}

export function getRemovedValues<T>(
  before: T[],
  after: T[],
  compare: (beforeElement: T, afterElement: T) => boolean = (beforeElement, afterElement) =>
    beforeElement === afterElement,
) {
  const removedValues = [...before];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < after.length; i++) {
    const afterElement = after[i];
    const notRemovedIndex = removedValues.findIndex((beforeElement) =>
      compare(beforeElement, afterElement),
    );
    if (notRemovedIndex !== -1) {
      removedValues.splice(notRemovedIndex, 1);
    }
  }
  return removedValues;
}

export function withoutDuplicates(array: any[]) {
  return array.reduce((result, element) => {
    if (result.indexOf(element) === -1) {
      result.push(element);
    }
    return result;
  }, []);
}
